import { Component, OnInit, Input, Output, EventEmitter, isDevMode, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { UtilsService } from '../../../services/utils/utils.service';
import { PresupuestoGuardarService } from '../../../../core/providers/services/presupuesto-guardar/presupuesto-guardar.service';
import { CommonService } from 'src/app/core/providers/forms/common.service';
import { environment } from 'src/environments/environment';
import { PolizasEmitirService } from 'src/app/core/providers/services/polizas-emitir/polizas-emitir.service';
import { DocumentacionCorreoService } from 'src/app/core/providers/services/documentacion-correo/documentacion-correo.service';
import { RentedService } from 'src/app/core/providers/services/rented-home/rented-home.service';
import { Numbers } from 'src/app/utils/constants';
import LegalStepThreeComponentUtils from './legal-step-three.component.utils';
import { ListaAseguradosAdicionalesInterface, PresupuestoGuardarInterface, TomadorPresupuestoInterface } from 'src/app/core/interfaces/presupuesto-guardar.interface';

@Component({
  selector: 'app-legal-step-three',
  templateUrl: './legal-step-three.component.html',
  styleUrls: ['./legal-step-three.component.scss']
})
export class LegalStepThreeComponent implements OnInit, OnDestroy {

  redsysRedirectUrl: string = environment.redsysRedirectUrl;
  @ViewChild('payform', { static: false }) payForm: ElementRef;
  @ViewChild('thanksB', { static: false }) thanksB: ElementRef;
  tpvParameters: any;

  //#region Constructor
  /**
   * @ignore
   */
  constructor(
    private commons: CommonService,
    private utilsSrv: UtilsService,
    private budgetSrv: PresupuestoGuardarService,
    private polSrv: PolizasEmitirService,
    private emailSrv: DocumentacionCorreoService,
    private rentedSrv: RentedService,
    private gtmService: GoogleTagManagerService
  ) {
    this.commons = commons;
    this.utilsSrv = utilsSrv;
    this.budgetSrv = budgetSrv;
    this.polSrv = polSrv;
    this.emailSrv = emailSrv;
    this.rentedSrv = rentedSrv;
    this.gtmService = gtmService;
    this.Utils = new LegalStepThreeComponentUtils();
  }

  /**
   * @description Es el formulario
   */
  @Input() FORM_DATA: FormGroup;

  /**
   * @description Es la configuracion del formulario
   */
  @Input() FORM_CONFIG: any;

  /**
   * @description Es el paso del formulario
   */
  @Input() STEP: any;

  @Output() CLICK_BTN: EventEmitter<'back' | 'next'> = new EventEmitter();
  @Output() INSURED_CHOOSED: EventEmitter<'Particular' | 'Empresa'> = new EventEmitter();

  finish = new Subject();
  insureSelected: string;
  currentStep = 0;
  formDataValue: any;
  patternEmail: RegExp = this.commons.patternsForm('email');
  patternMobile: RegExp = this.commons.patternsForm('mobile');
  patternCP: RegExp = this.commons.patternsForm('cp');
  patternPassport: RegExp = this.commons.patternsForm('passport');
  idPresu = 0;
  polizaData: any;
  clickBtnValue = '';
  public showModal = false;
  public showModalT = false;
  displayModal: boolean;
  displayModal2: boolean;
  displayErrorTerms: boolean;
  precioProducto: number;
  showTPV = false;
  email: string;
  success: boolean;
  showThanks = false;
  showLoader = false;
  stepActive = '4';
  rute = '/';
  Utils: LegalStepThreeComponentUtils;
  errorDesc = '';
  /**
   * @ignore
   */
  ngOnInit() {
    this.currentStep = this.STEP;
    this.getProductChoosed();
    this.initSubs();
    this.setValidator();
    window.scrollTo(0, 0);
  }
  /**
   * @ignore
   */
  ngOnDestroy() {
    this.finish.next(true);
  }
  /**
   * @description Recupera el tipo de formulario
   */
  getProductChoosed(): void {
    if (this.FORM_DATA) {
      this.insureSelected = this.FORM_DATA.get('insureSelected').value.chosed;
    }
  }
  /**
   * @description Definición inicial del paso
   */
  initSubs(): void {
    this.formDataValue = this.FORM_DATA.get(this.insureSelected).value;
    this.FORM_DATA.get(this.insureSelected).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(() => {
          this.formDataValue = this.FORM_DATA.get(this.insureSelected).value;
        })
      ).subscribe();
  }
  /**
   * @param ev evento
   * @description botón siguiente o anterior
   */
  public clickButton(ev: 'back' | 'next'): void {
    if (ev === 'next') {
      this.clickBtnValue = 'next';
      if (this.FORM_DATA.valid) {
        this.callPresupuestoGuardar();
      } else {
        const formValues: any = this.FORM_DATA.get(this.insureSelected).value;
        const acceptTerms: boolean = formValues.domiciliation.acceptTerms;
        if (acceptTerms === false) {
          this.showModalTerms();
        }
      }
    } else {
      this.clickBtnValue = 'back';
      localStorage.removeItem('stepThanks');
      this.removeValidator();
      this.CLICK_BTN.emit(ev);
    }
  }

  /**
   * @description asignar las validaciones del paso
   */
  public setValidator(): void {
    this.FORM_DATA.get(this.FORM_CONFIG.acceptTerms.linkFormPath).setValidators([Validators.required]);
    this.FORM_DATA.get(this.FORM_CONFIG.treatmentOfData.linkFormPath).setValidators([this.validTreatment]);
    this.FORM_DATA.get(this.FORM_CONFIG.acceptTerms.linkFormPath).updateValueAndValidity();
    this.FORM_DATA.get(this.FORM_CONFIG.treatmentOfData.linkFormPath).updateValueAndValidity();
  }

  /**
   * Validate if the treatment of data is marked
   * @param control control treatment
   * @returns validationError
   */
  public validTreatment(control: FormControl): ValidationErrors {
    let validationErrors: ValidationErrors = null;
    if (control.value[0].Aceptacion === '0') {
      validationErrors = { opcionInvalida: true };
    }
    return validationErrors;
  }

  /**
   * @description remover las validaciones del paso
   */
  public removeValidator(): void {
    this.FORM_DATA.get(this.FORM_CONFIG.acceptTerms.linkFormPath).clearValidators();
    this.FORM_DATA.get(this.FORM_CONFIG.adequacyOfProduct.linkFormPath).clearValidators();
    this.FORM_DATA.get(this.FORM_CONFIG.iban.linkFormPath).clearValidators();
    this.FORM_DATA.get(this.FORM_CONFIG.treatmentOfData.linkFormPath).clearValidators();
    this.FORM_DATA.get(this.FORM_CONFIG.swift.linkFormPath).clearValidators();
    this.FORM_DATA.get(this.FORM_CONFIG.acceptTerms.linkFormPath).updateValueAndValidity();
    this.FORM_DATA.get(this.FORM_CONFIG.adequacyOfProduct.linkFormPath).updateValueAndValidity();
    this.FORM_DATA.get(this.FORM_CONFIG.iban.linkFormPath).updateValueAndValidity();
    this.FORM_DATA.get(this.FORM_CONFIG.treatmentOfData.linkFormPath).updateValueAndValidity();
  }
  /**
   * @description retorna si se muestra el modal condiciones
   */
  showModalTerms(): void {
    this.displayErrorTerms = true;
    this.showModalT = this.displayErrorTerms;
  }

  /**
   * @description Asigna valores tomador del presupuesto
   * @return any
   */
  tomadorPres(): TomadorPresupuestoInterface[] {
    let indCif = 0;
    // 1 NIF => 2 CIF => 3 NIE => 4 pas
    if (this.formDataValue.insuredData.documentType.name === 'CIF') { indCif = 1; }

    let cif = '';
    if (this.formDataValue.insuredData.documentType.name !== 'Pasaporte') { cif = this.formDataValue.insuredData.documentNumber; }
    let pasaporte = '';
    if (this.formDataValue.insuredData.documentType.name === 'Pasaporte') { pasaporte = this.formDataValue.insuredData.documentNumber; }
    const separarPrefijo: any = this.formDataValue.insuredData.prefix.split('(');
    const prefijo: any = separarPrefijo[1].split(')');
    const tomadorPresupuesto: TomadorPresupuestoInterface[] = [
      {
        Id_Presupuesto: 0,
        nombreRazonSocial: this.formDataValue.insuredData.name,
        documento: cif,
        tipoDocumento: this.formDataValue.insuredData.documentType.name,
        apellido1: this.formDataValue.insuredData.firstSurname,
        apellido2: this.formDataValue.insuredData.secondSurname,
        direccion: this.formDataValue.insuredData.direction,
        idMunicipio: this.formDataValue.insuredData.municipality.id,
        municipio: this.formDataValue.insuredData.municipality.name,
        telDomicilio: '',
        telMovil: prefijo[0] + this.formDataValue.insuredData.telephone,
        telTrabajo: '',
        fax: '',
        emailTomador: this.formDataValue.insuredData.email,
        indDomiciliar: 1,
        idViaPago: Numbers.number20,
        entidad: '',
        sucursal: '',
        DC: '',
        cuenta: '',
        idCliente: 0,
        iban: this.formDataValue.domiciliation.iban,
        swift: this.formDataValue.domiciliation.swift,
        cp: this.formDataValue.insuredData.postalCode,
        idProvincia: Numbers.number28,
        provincia: this.formDataValue.insuredData.province,
        pais: this.formDataValue.insuredData.country.name,
        idSector: Numbers.number19130,
        indCif, // 1 NIF => 2 CIF => 3 NIE => 4 pas
        CIF: cif, // numero de documento
        Pasaporte: pasaporte,
        idCcc: 0
      }
    ];

    return tomadorPresupuesto;
  }
  /**
   * @description Asigna valores condiciones adicionales del presupuesto
   * @returns any
   */
  aditionalPres(): ListaAseguradosAdicionalesInterface[] {
    const dateToday: string = this.utilsSrv.getDateToday();
    const aditionalPres: ListaAseguradosAdicionalesInterface[] = [
      {
        idAsegurado: 0,
        nombreAsegurado: this.formDataValue.insuredData.name,
        apellido1Asegurado: this.formDataValue.insuredData.firstSurname,
        apellido2Asegurado: this.formDataValue.insuredData.secondSurname,
        nifAsegurado: this.formDataValue.insuredData.documentNumber,
        fechaNacimientoAsegurado: '2000-01-01',
        ambitoOrigen: this.formDataValue.countryOriginEnvironment,
        ambitoDestino: this.formDataValue.countryDestinyEnvironment,
        tipoCoberturaAsegurado: this.getCoverageType(),
        fecEfecto: this.utilsSrv.changeDateOrderToService(this.formDataValue.dateStart),
        fecVencimiento: this.utilsSrv.changeDateOrderToService(this.formDataValue.dateEnd),
        idSobrePrimaAsegurado: 0,
        desDescuento: this.formDataValue.codePromotional,
        email: this.formDataValue.insuredData.email,
        idTipoDescuento: 0,
        fecTarificacion: dateToday,
        idPoliza: '0'
      }
    ];

    return aditionalPres;
  }
  /**
   * @description Asigna valores de consentimientos del presupuesto
   * @returns any
   */
  consentimientosPresu(): {idTipoConsentimiento: number; aceptacion: number}[] {
    const listado: {idTipoConsentimiento: number; aceptacion: number}[] = [
      {
        idTipoConsentimiento: Numbers.number1,
        aceptacion: parseInt(this.formDataValue.termsList[Numbers.number0].Aceptacion, Numbers.number10)
      },
      {
        idTipoConsentimiento: Numbers.number15,
        aceptacion: parseInt(this.formDataValue.termsList[Numbers.number1].Aceptacion, Numbers.number10)
      },
      {
        idTipoConsentimiento: Numbers.number9,
        aceptacion: parseInt(this.formDataValue.termsList[Numbers.number2].Aceptacion, Numbers.number10)
      },
      {
        idTipoConsentimiento: Numbers.number16,
        aceptacion: parseInt(this.formDataValue.termsList[Numbers.number3].Aceptacion, Numbers.number10)
      }
    ];

    return listado;
  }
  /**
   * @description Generar presupuesto a guardar
   */
  callPresupuestoGuardar(): void {
    let idProveedorWeb = 1;
    let auxIdProduct: number = Numbers.number17049;
    if (this.formDataValue.insuranceType.priority === 0) { auxIdProduct = Numbers.number17048; }
    if (this.formDataValue.idCorreduria !== '') {
      idProveedorWeb = this.formDataValue.idCorreduria;
    } else {
      idProveedorWeb = 1;
    }
    const dateToday: string = this.utilsSrv.getDateToday();
    const numberOfInsureds: number = this.formDataValue.numberOfInsured;

    const viajerosBase: any = {
      Id_Presupuesto: 0,
      ambitoOrigen: this.formDataValue.countryOriginEnvironment,
      ambitoDestino: this.formDataValue.countryDestinyEnvironment,
      expatriado: true,
      numDias: this.formDataValue.insuranceTime
    };
    const viajerosNormales: any = {
      ...viajerosBase,
      numViajeros: numberOfInsureds,
      idSobrePrima: 0
    };
    const obj: PresupuestoGuardarInterface = {
      idProducto: auxIdProduct,
      fecEfecto: this.utilsSrv.changeDateOrderToService(this.formDataValue.dateStart),
      fecVencimiento: this.utilsSrv.changeDateOrderToService(this.formDataValue.dateEnd),
      listaViajeros: [
        viajerosNormales
      ],
      precioPresupuesto: +this.formDataValue.insuranceType.price,
      // Id_proveedor: 1,
      idProveedor: idProveedorWeb,
      tomadorPresupuesto: this.tomadorPres(),
      indCondiciones: 1,
      emNombre: '',
      emApe1: '',
      emApe2: '',
      emRelacionAsegurado: '',
      emTel1: '',
      desDescuento: this.formDataValue.codePromotional,
      listaAseguradosAdicionales: this.aditionalPres(),
      procedencia: 'WEB',
      fecTarificacion: dateToday,
      derogaciones: [],
      descuentoMediador: 0,
      nombrePresupuesto: 'Proyecto',
      accion: 0,
      idPresupuestoActualizar: 0,
      viajesPersonales: 0,
      idPortal: 1,
      idComercial: 0,
      garantias: this.Utils.getGarantees(this.formDataValue),
      idModalidad: 1,
      idAmbitoOrigen: this.formDataValue.countryOriginEnvironment,
      idAmbitoDestino: +this.formDataValue.countryDestinyEnvironment,
      indReceptivo: false,
      unidadFamiliar: false,
      idFraccionamientoPago: 0,
      slCodigoAgencia: '',
      slComision: '',
      slDistrito: '',
      slMonitor: '',
      slNifAuxiliarExterno: '',
      slZona: '',
      idRedProduccion: '13',
      listadoConsentimientos: this.consentimientosPresu(),
      renta: 0,
      indRenovacionAuto: true,
      idSubtipoPoliza: Numbers.number2,
      idTipoRenovacionAsegurado: Numbers.number2,
      indRenovableTemporal: true,
      indPolizaMarco: false,
      tipoCobertura: this.getCoverageType(),
      numOpcionContratacion: Numbers.number2,
      idSobreprima: 0,
      listaPaises: [],
      deporte: [],
      AutorizadoFirma: true
    };
    const presu: any = obj;
    this.showLoader = true;
    this.budgetSrv.postBudgetSave(presu)
      .pipe(take(1))
      .subscribe((budgetSaved: any) => {
        this.idPresu = 0;
        if (budgetSaved.idError !== 0) {
          this.errorDesc = budgetSaved.desError;
        } else {
          this.errorDesc = '';
        }
        if (budgetSaved.idPresupuesto !== undefined) { this.idPresu = budgetSaved.idPresupuesto; }
        if (this.idPresu > 0) {
          localStorage.setItem('email', this.formDataValue.insuredData.email);
          const auxRented: any = this.formDataValue.insuredData.rentedHouse;
          if (auxRented) {
            this.domicilioalquilado();
          } else {
            this.emitPolicy();
          }
        }
      });
  }

  /**
   * @description Recupera las coberturas del presupuesto
   * @returns string
   */
  getCoverageType(): string {
    return 'Anual_+90';
  }

  /**
   * @description Se asigna y envía los datos del domicilio alquilado
   */
  domicilioalquilado(): void {
    // rentedSrv
    const data: any = {
      idPresu: this.idPresu,
      idDomicilio: 1,
      direction: this.formDataValue.insuredData.rentedHouseData.direction,
      cp: this.formDataValue.insuredData.rentedHouseData.postalCode,
      idMunicipio: this.formDataValue.insuredData.rentedHouseData.municipality.id,
      idProvincia: this.formDataValue.insuredData.rentedHouseData.provinceId,
      renta: 0,
      direccionInquilino: '',
      cpInquilino: '',
      idProvinciaInquilino: '',
      idMunicipioInquilino: '',
      nombreInquilino: '',
      apellido1Inquilino: '',
      apellido2Inquilino: '',
      tipoNif: '',
      nif: ''
    };
    this.rentedSrv.domicilioalquilado(data)
      .pipe(take(1))
      .subscribe((sendPol: any) => {
        let auxSend = false;
        if (sendPol.idError !== undefined ||  sendPol.idError !== 200) { auxSend = true; }
        if (auxSend) {
          this.emitPolicy();
        }
      });
  }
  /**
   * @description Se emite la poliza
   */
  emitPolicy(): void {
    const data: any = {
      idPresupuesto: this.idPresu,
      documento: this.formDataValue.insuredData.documentNumber,
      email: this.formDataValue.insuredData.email,
      numeroConfirmacion: '000000',
      codigoVenta: '0000',
      tieneAsegurados: false
    };
    this.Utils.datalayer2(this.FORM_DATA, this.gtmService);
    this.Utils.datalayer(this.idPresu, parseFloat(this.formDataValue.insuranceType.price), this.FORM_DATA, this.gtmService);
    this.polSrv.postPolicySend(data, true)
      .pipe(take(1))
      .subscribe((sendPol: any) => {
        let auxSend = false;
        if (sendPol.idError !== undefined && sendPol.idError === 0) { auxSend = true; }
        if (auxSend) {
          this.polizaData = sendPol;
          this.sendEmail();
        } else {
          localStorage.setItem('stepThanks', 'true');
          this.setStepThanks();
          this.success = false;
          localStorage.removeItem('budget');
        }
      });

    localStorage.removeItem('budget');
  }
  /**
   * @description Se envía los datos al servicio de correo
   */
  sendEmail(): void {
    this.email = localStorage.getItem('email');
    const a: any = {
      idPoliza: this.polizaData.idPoliza,
      indEmail: true,
      email: this.email
    };
    this.emailSrv.postDocumentationEmail(a)
      .pipe(take(1))
      .subscribe((emailD: any) => {
        localStorage.removeItem('stepThanks');
        this.success = true;
        localStorage.setItem('stepThanks', 'true');
        this.CLICK_BTN.emit('next');
      });
  }
  /**
   * @description Se envía la respuesta para mostrar el mensaje de gracias o error
   */
  setStepThanks(): void {
    this.stepActive = localStorage.getItem('stepThanks');
    if (this.stepActive !== '' && this.stepActive !== null) {
      this.showThanks = true;
    }
  }
}
